<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="单位名称"
                prop="danwei"
                :rules="[
                { required: true, message: '请输入单位名称', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.danwei"
                  type="text"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="考级时间"
                prop="datetitle"
                :rules="[
                { required: true, message: '请选择考级时间' },
              ]"
            >
              <el-date-picker
                  v-model="formData.datetitle"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="请选择考级时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="考试星级" prop="star_type"
                          :rules="[
                { required: true, message: '请选择考试星级' },
              ]"
            >
              <el-checkbox-group v-model="formData.star_type">
                <el-checkbox :label="item.text" v-for="item in starList">{{ item.text }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="省市地区"
                prop="area"
                :rules="[
                {
                  required: true,
                  message: '请选择地区',
                },
              ]"
            >
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="考级地址"
                prop="address"
                :rules="[
                { required: true, message: '请输入考级地址', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.address"
                  type="text"
                  placeholder="请输入考级地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="本机构考官"
                prop="jigou"
                :rules="[
              ]"
            >
              <div style="cursor: pointer" @click="onKaoguanShow">请选择人员 <i class="el-icon-arrow-right"></i></div>
              <div v-show="formData.jigoukaoguan.length>0">
                <div class="memberLi" v-for="(kaoguan ,index) in formData.jigoukaoguan" :key=index>
                  <el-tag
                      :key="index"
                      round
                      closable
                      type="primary"
                      @close="formData.jigoukaoguan.splice(index,1)"
                  > {{ kaoguan.name }}({{ kaoguan.grade }})
                  </el-tag>
                </div>
              </div>
              <div class="form-label-desc">本机构考官选填</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="非机构考官"
                prop="no-jigou"
                :rules="[
              ]"
            >
              <el-button type="mini" @click="getKaoguanRand">{{
                  kaoguanWaitList.length > 0 ? '更换一波' : '随机筛选'
                }}
              </el-button>
              <div class="kaoguan-box">
                <div style="border-top: 1px solid #eeee;padding: 5px 0 5px 10px;">已选考官名单</div>

                <el-tag
                    v-for="(kaoguan ,index) in formData.kaoguan"
                    :key="index"
                    round
                    closable
                    type="primary"
                    @close="formData.kaoguan.splice(index,1)"
                > {{ kaoguan.name }}({{ kaoguan.grade }}) <a :href="'tel:'+kaoguan.phone">{{ kaoguan.phone }}</a>
                </el-tag>
              </div>
              <div class="kaoguan-box" v-if="kaoguanWaitList.length > 0">
                <div style="border-top: 1px solid #eeee;padding: 5px 0 5px 10px;">待选考官</div>
                <van-tag
                    v-for="(kaoguan ,index) in kaoguanWaitList"
                    :key="index"
                    size="large"
                    plain
                    closable
                    type="primary"
                > {{ kaoguan.name }}({{ kaoguan.grade }}) <span>{{kaoguan.phone}}</span> <div class="small-button" style="margin-left: 5px" @click="onKaoguanChoose(kaoguan)">选择</div>
                </van-tag>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="监督选择"
                prop="jiandu"
                :rules="[
              ]"
            >
              <el-button type="mini" @click="getJianduRand">{{
                  formData.jiandu.length > 0 ? '更换一波' : '随机筛选'
                }}
              </el-button>
              <div class="kaoguan-box">
                <el-tag
                    v-for="(jiandu ,index) in formData.jiandu"
                    :key="index"
                    round
                    closable
                    type="primary"
                    @close="formData.jiandu.splice(index,1)"
                > {{ jiandu.name }} <a :href="'tel:'+jiandu.phone">{{jiandu.phone}}</a>
                </el-tag>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
                label="联系人电话"
                prop="phone"
                :rules="[
                { required: true, validator: validator.phone,message:'请输入日常联系人电话', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  type="text"
                  placeholder="请输入日常联系人电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>

      </el-form>
      <KaoguanPicker
          :show="showKaoguanPicker"
          :limit="1"
          :grade="grade"
          :isStartLoading=false
          @onChange="onKaoguanChange"
          @onClose="showKaoguanPicker=false"
          :defaultValue="formData.jigoukaoguan"
          @onConfirm="onKaoguanConfirm"
      ></KaoguanPicker>
      <!--    <KaoguanPicker-->
      <!--        :show="showKaoguanPicker"-->
      <!--        :limit="6"-->
      <!--        @onChange="onKaoguanChange"-->
      <!--        @onClose="showKaoguanPicker=false"-->
      <!--        :defaultValue="formData.jigou"-->
      <!--        @onConfirm="onKaoguanConfirm"-->
      <!--    ></KaoguanPicker>-->
      <JianduPicker
          :show="showJianduPicker"
          :limit="1"
          @onChange="onJianduChange"
          @onClose="showJianduPicker=false"
          :defaultValue="formData.jiandu"
          @onConfirm="onJianduConfirm"
      ></JianduPicker>
      <CenterPicker
          :show="showCenterPicker"
          :limit="1"
          @onChange="onCenterChange"
          @onClose="showCenterPicker=false"
          :defaultValue="formData.extra_center"
          @onConfirm="onCenterConfirm"
      ></CenterPicker>
      <van-popup v-model="showDate" position="bottom">
        <van-datetime-picker
            @cancel="showDate =false"
            title="选择年月日"
            type="date"
            :default-date='new Date( (formData.datetitle? formData.datetitle :"" ).replace(/-/g,"/") )'
            :min-date="minDate"
            @confirm="onDateConfirm"/>
      </van-popup>
    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 28px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
}

.kaoguan-box .van-tag {
  margin-bottom: .1rem;
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-left: 10px;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import KaoguanPicker from '@/components/picker/KaoguanPicker.vue';
import JianduPicker from '@/components/picker/JianduPicker.vue';
import CenterPicker from '@/components/picker/CenterPicker.vue';

import {
  Cell,
  Field,
  Area,
  DatetimePicker,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  Calendar
} from 'vant';

Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'StationApply',
  components: {
    PicUploader,
    KaoguanPicker,
    JianduPicker,
    CenterPicker,
  },
  data: function () {
    return {
      validator,
      showDate: false,
      showKaoguanPicker: false,
      showCenterPicker: false,
      showJianduPicker: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',
      row: {},
      starList: [{id: 1, text: '红星级'}, {id: 2, text: '橙星级'}, {id: 3, text: '黄星级'}, {id: 4, text: '绿星级'}, {
        id: 5,
        text: '青星级'
      }, {id: 6, text: '蓝星级'}, {id: 7, text: '紫星级'}],
      minDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + 3600 * 24 * 15 * 1000), //15天后
      formData: {
        id: 0,
        datetitle: '',
        areas: '',
        jigoukaoguan: [],
        kaoguan: [],
        jiandu: [],
        extra_center: [],
        star_type: [],
        province: '',
        city: '',
        county: '',
      },

      grade: '',
      jianduList: [],
      kaoguanList: [],
      kaoguanWaitList: []
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    document.title = '申报星级'
    that.formData.id = this.$route.query.id || 0;
    if (that.formData.id) {
      // this.fetch();
    }
    this.getSetting();
    this.getAreaOptions();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },
    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      // this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
      this.formData.datetitle = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },

    onKaoguanShow() {
      let that = this,
          startList = that.formData.star_type,
          gradeList = []
      startList.map(type => {
        gradeList.push(type.text)
      })

      if (!gradeList.length) {
        that.$message.warning("请先选择考试星级")
        return
      }

      // 增加星级筛选
      this.grade = that.getGrade(gradeList)
      this.showKaoguanPicker = true
    },
    getKaoguanRand() {
      let that = this,
          startList = that.formData.star_type,
          gradeList = []
      startList.map(type => {
        gradeList.push(type.text)
      })
      if (that.kaoguanList.length > 0) {
        that.getKaoguanValue()
        return
      }
      // console.log(gradeList,gradeList.indexOf('青星级'))

      if (!gradeList.length) {
        that.$message.warning("请先选择考试星级")
        return
      }

      // 增加星级筛选
      let grade = that.getGrade(gradeList)

      that.$api.post('/api/kaoguan/optionsRand', {
        center_id: that.$route.query.id,
        limit: 9,
        grade: grade
      }, (res) => {
        if (!res.data.length) {
          that.$message.warning('没有相关等级的考官')
        }
        that.kaoguanList = res.data
        that.getKaoguanValue()
      }, (res) => {
        that.$message.warning(res.msg);
      })
    },

    getGrade(gradeList) {
      let grade = ''
      if (gradeList.indexOf('蓝星级') >= 0 || gradeList.indexOf('紫星级') >= 0) {
        grade = '高级'
      } else if (gradeList.indexOf('绿星级') >= 0 || gradeList.indexOf('青星级') >= 0) {
        grade = '中级高级'
      }
      return grade;
    },
    getJianduRand() {
      let that = this
      // formData.jiandu 有值，从数组中随机筛选
      if (that.jianduList.length > 0) {
        that.getJianduValue()
        return
      }

      that.$api.post('/api/jiandu/optionsRand', {
        center_id: that.$route.query.id,
        limit: 3
      }, (res) => {
        that.jianduList = res.data

        that.getJianduValue()
      }, (res) => {
        that.$message.warning(res.msg);
      })
    },

    getKaoguanValue() {
      let that = this,
          kaoguan = that.kaoguanWaitList,
          kaoguanList = []
      // that.kaoguanList.map(row => {
      //   kaoguan.map(value => {
      //     if(row.id != value.id) {
      //       kaoguanList.push(row)
      //     }
      //   })
      // })

      kaoguanList = [...that.kaoguanList].filter(x => [...kaoguan].every(y => y.id !== x.id))
      console.log('kaoguanList', kaoguanList)

      if (!kaoguan.length) {
        kaoguanList = that.kaoguanList
      }

      // let length = kaoguan.length >= 3 ? 0 : 3 - kaoguan.length;
      let length = 3;
      let kaoguanValue = that.getRandomArr(kaoguanList, length)

      if (!kaoguanValue.length) return
      that.kaoguanWaitList = kaoguanValue
      console.log(that.formData.kaoguan, that.kaoguanList, length)
    },

    // 选择考官
    onKaoguanChoose(kaoguan) {
      let count = 0
      this.formData.kaoguan.map(row => {
        if (row.id == kaoguan.id) {
          this.$message.warning(kaoguan.name + ' 考官已选择')
          count++
        }
      })
      if (count) return
      this.formData.kaoguan.push(kaoguan)
    },

    getJianduValue() {
      let that = this,
          jiandu = that.formData.jiandu,
          jianduList = []

      if (!that.jianduList.length) {
        that.formData.jiandu = []
        that.$message.warning('暂无所属地区监督人员数据')
        return
      }

      that.jianduList.map(row => {
        jiandu.map(value => {
          if (row.id != value.id) {
            jianduList.push(row)
          }
        })
      })

      if (!jiandu.length) {
        jianduList = that.jianduList
      }

      // console.log(jianduList[Math.floor(Math.random()*jianduList.length)])

      // let jiandu = [jianduList[Math.floor(Math.random()*jianduList.length)]]
      let jianduValue = that.getRandomArr(jianduList, 1)

      that.formData.jiandu = jianduValue
      console.log(jianduList)
    },

    getRandomArr(arr, count) {//随机抽取
      var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
      while (i-- > min) {//打乱数组
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },

    onKaoguanConfirm(values) {
      console.log('onKaoguanConfirm', values)
      this.showKaoguanPicker = false;
      this.formData.jigoukaoguan = [...values];
    },
    onKaoguanChange(values) {
      console.log('onKaoguanChange', values)
      this.formData.jigoukaoguan = [...values];
    },
    onJianduConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showJianduPicker = false;
      this.formData.jiandu = [...values];
    },
    onJianduChange(values) {
      console.log('onJianduChange', values)
      this.formData.jiandu = [...values];
    },
    onCenterChange(values) {
      console.log('onCenterChange', values)
      this.formData.extra_center = [...values];
    },
    onCenterConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showCenterPicker = false;
      this.formData.extra_center = [...values];
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          // 绿色星级及以上必须选择考级中心
          let isGreenUp = false
          this.formData.star_type.map(star => {
            if (star.id >= 4) {
              isGreenUp = true
            }
          })
          console.log(that.formData.extra_center)
          // return
          // if(isGreenUp && !that.formData.extra_center.length) {
          //   Toast('考级点如需申报绿星级及以上星级的考级，请选择考级中心')
          //   return
          // }

          for (let field in that.formData) {
            if (!this.formData.star_type.length) {
              that.$message.warning('请选择星级');
              return
            }

            if (!this.formData.area) {
              that.$message.warning('请选择地区');
              return
            }
            if (!this.formData.jiandu.length) {
              // Toast('请选择监督');
              // return
              // this.formData.jiandu = []
            }
            // 考官总数 不少于2个
            if ((this.formData.kaoguan.length + this.formData.jigoukaoguan.length) < 2) {
              that.$message.warning('至少选择2个考官');
              return
            }
          }
          that.saveLoading = true;

          if (that.submitType == 'save') {
            that.$api.post('/api/qcxj/kaojiApplySave', that.formData, (res) => {
              that.saveLoading = false;
            }, (res) => {
              that.$message.warning(res.msg);
              that.saveLoading = false;
            })
          } else {
            that.$api.post('/api/qcxj/kaojiApplyAddSimple', that.formData, (res) => {
              that.saveLoading = false;

              if (!this.formData.jiandu.length) {
                // Toast('请选择监督');
                // return
                that.$message.warning("你没有选择监督 请联系工作人员")
                setTimeout(function () {
                  rbLink({
                    'name': 'ExameApplyDetailMine',
                    'query': {
                      id: res.data.id
                    }
                  }, 'back')
                }, 1000)
              } else {
                rbLink({
                  'name': 'ExameApplyDetailMine',
                  'query': {
                    id: res.data.id
                  }
                }, 'back')
              }

            }, (res) => {
              that.$message.error(res.msg);
              that.saveLoading = false;
            })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      // 绿色星级及以上必须选择考级中心
      let isGreenUp = false
      this.formData.star_type.map(star => {
        if (star.id >= 4) {
          isGreenUp = true
        }
      })
      console.log(that.formData.extra_center)
      // return
      // if(isGreenUp && !that.formData.extra_center.length) {
      //   Toast('考级点如需申报绿星级及以上星级的考级，请选择考级中心')
      //   return
      // }

      for (let field in that.formData) {
        if (!this.formData.star_type.length) {
          that.$message.warning('请选择星级');
          return
        }

        if (!this.formData.area) {
          that.$message.warning('请选择地区');
          return
        }
        if (!this.formData.jiandu.length) {
          // Toast('请选择监督');
          // return
          // this.formData.jiandu = []
        }
        // 考官总数 不少于2个
        if ((this.formData.kaoguan.length + this.formData.jigoukaoguan.length) < 2) {
          that.$message.warning('至少选择2个考官');
          return
        }
      }
      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/qcxj/kaojiApplySave', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          that.$message.warning(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/qcxj/kaojiApplyAddSimple', that.formData, (res) => {
          that.saveLoading = false;

          if (!this.formData.jiandu.length) {
            // Toast('请选择监督');
            // return
            that.$message.warning("你没有选择监督 请联系工作人员")
            setTimeout(function () {
              rbLink({
                'name': 'ExameApplyDetailMine',
                'query': {
                  id: res.data.id
                }
              }, 'back')
            }, 1000)
          } else {
            rbLink({
              'name': 'ExameApplyDetailMine',
              'query': {
                id: res.data.id
              }
            }, 'back')
          }

        }, (res) => {
          that.$message.warning(res.msg);
          that.saveLoading = false;
        })
      }
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo, this.formData);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/qcxj/applydetail', {
        id: that.formData.id
      }, (res) => {
        that.formData = res.data;
      }, (res) => {
        that.$message.warning(res.msg);
      })
    },
    getSetting() {
      let that = this;
      that.$api.post('/api/qcxj/getSetting', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        that.$message.warning(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// ExameApplyFormBasicMine.vue?6d341544